export default {
  items: [
    {
      name: '',
      url: '/collections',
      icon: 'icon-home',
      badge: {
        variant: 'primary'      
      }
    },
    {
      name: '',
      url: '/allrecords',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'      
      }
    },
    {
      name: '',
      url: '/sampling_requested',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'      
      }
    }
    
   
     /*{
      name: 'Cod Management',
      url: '/codcashmanage',
      icon: 'icon-layers'
    },
     {
      name: 'User  Dashboard',
      url: '/userwisefinince_dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'      
      }
    },
      {
      name: 'Rider  Dashboard',
      url: '/riderwisefinince_dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'      
      }
    },
    
     {
      name: 'Receipt Tracker',
      url: '/receiptTracker',
      icon: 'fa fa-stack-exchange',
      badge: {
        variant: 'primary'      
      }
    },
   
    {
      name: 'MIS Report',
      url: '/misreport',
      icon: 'icon-location-pin',
      badge: {
        variant: 'primary'      
      }
    },
    {
          name: 'Shipment Tracking',
          url: '/consignmenttracking', 
         icon: 'icon-location-pin',
      badge: {
        variant: 'primary'      
      }
        },*/
  
   
  ]
}